import React, {Dispatch, FC, SetStateAction} from "react";
import NcImage from "../../ui/shared/NcImage/NcImage";
import HotelRoom from "../../hotels/types/HotelRoom";
import HotelRoomImage from "../../hotels/types/HotelRoomImage";

export interface BookingItemCardProps {
    roomImages:  HotelRoomImage[];
    hotelRoom: HotelRoom
    setIsGalleryOpen: Dispatch<SetStateAction<boolean>>;
}

const RoomHotelEventCardImage: FC<BookingItemCardProps> = ({roomImages, hotelRoom, setIsGalleryOpen}) => {

    return (
        <>
            <div
              className="w-40 h-40 flex-shrink-0 rounded-lg overflow-hidden cursor-pointer hover:opacity-80 transition-opacity"
              onClick={() => roomImages.length > 0 && setIsGalleryOpen(true)}
            >
                <NcImage
                  containerClassName="w-full h-full"
                  className="object-cover w-full h-full rounded-lg"
                  src={hotelRoom.principalImgContentUrl}
                />
            </div>
        </>
    );
}

export default RoomHotelEventCardImage;
